import { Routes } from '@angular/router';
import { secureRoutes } from './secure/secure.routes';
import { publicRoutes } from './public/public.routes';

export const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'secure',
    },
    ...secureRoutes,
    ...publicRoutes,
];

